import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'sura-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sura-loader.component.html',
  styleUrl: './sura-loader.component.scss',
})
export class SuraLoaderComponent {
  text = input<string>('Estamos consultando tus datos...');
}
